<template>
  <v-card :style="{ 'background-color': teamColor }">
    <v-card-title
      class="justify-center"
      :style="{ color: textColor(teamColor) }"
    >
      <v-btn
        v-if="player.team !== teamName"
        color="secondary"
        @click="$emit('joinTeam', teamName)"
      >
        Join team {{ teamName }}
      </v-btn>
      <span v-else style="padding: 2px 0;">Team {{ teamName }}</span>
    </v-card-title>
    <v-list
      v-if="teamPlayer.length > 0"
      style="border-top-left-radius: 0; border-top-right-radius: 0;"
    >
      <template v-for="(p, index) in teamPlayer">
        <v-list-item
          :class="{ 'font-weight-bold': p.name === player.name }"
          :key="p.id"
        >
          <v-list-item-content>
            {{ p.name }}{{ p.isCodeMaster ? ' (Codemaster)' : '' }}
          </v-list-item-content>
        </v-list-item>
        <v-divider
          v-if="index + 1 < teamPlayer.length"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import colors from '../utils/colors';
import textColor from '../utils/textColor';

export default {
  name: 'Team',
  props: {
    teamName: {
      type: String,
      required: true,
    },
    teamPlayer: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    player: {
      type: Object,
      required: true,
    },
  },
  computed: {
    teamColor() {
      return this.teamName === 'A' ? colors.teamA : colors.teamB;
    },
  },
  methods: {
    textColor: textColor,
  },
};
</script>
